<div>
  <h2>{{ 'TYPOGRAPHY.TITLES' | translate }}</h2>
  <hr class="mb-6" />
  <div class="gap-5">
    <div class="gap-3">
      <h1 #h1>H1 Headline</h1>
      <span class="info">{{ info(h1) }}</span>
    </div>
    <div class="gap-3">
      <h2 #h2>H2 Headline</h2>
      <span class="info">{{ info(h2) }}</span>
    </div>
    <div class="gap-3">
      <h3 #h3>H3 Headline</h3>
      <span class="info">{{ info(h3) }}</span>
    </div>
    <div class="gap-3">
      <h4 #h4>H4 Headline</h4>
      <span class="info">{{ info(h4) }}</span>
    </div>
    <div class="gap-3">
      <h5 #h5>H5 Headline</h5>
      <span class="info">{{ info(h5) }}</span>
    </div>
  </div>
</div>

<ng-template #text let-classes="classes" let-text="text">
  <div class="gap-3">
    <p #el [ngClass]="classes" [vitamuiTooltip]="'TYPOGRAPHY.TOOLTIP' | translate: { classes: classes.join(' ') }">
      {{ text }}
    </p>
    <span class="info">{{ info(el) }}</span>
  </div>
</ng-template>

<div>
  <hr />
  <p>
    <i class="vitamui-icon vitamui-icon-info"></i>
    {{ 'TYPOGRAPHY.INFO' | translate }}
  </p>
  <hr />
</div>

<div>
  <h2>{{ 'TYPOGRAPHY.TEXT' | translate }}</h2>
  <hr class="mb-6" />
  <div class="hgap-6">
    @for (textFlavor of textFlavors; track textFlavor) {
      <div class="gap-5">
        @for (textSize of textSizes; track textSize) {
          <ng-container
            [ngTemplateOutlet]="text"
            [ngTemplateOutletContext]="{ classes: ['text', textFlavor, textSize], text: textSize + ' text ' + textFlavor }"
          >
          </ng-container>
        }
      </div>
    }
  </div>
</div>

<div>
  <h2>{{ 'TYPOGRAPHY.LINK_AND_BUTTON' | translate }}</h2>
  <hr class="mb-6" />
  <div class="gap-8">
    <div class="hgap-6">
      @for (textLinkFlavor of textLinkFlavors; track textLinkFlavor) {
        <div class="gap-5">
          @for (textSize of textSizes; track textSize) {
            <ng-container
              [ngTemplateOutlet]="text"
              [ngTemplateOutletContext]="{
                classes: ['text', 'link', textSize, textLinkFlavor],
                text: textSize + ' link ' + textLinkFlavor,
              }"
            >
            </ng-container>
          }
        </div>
      }
    </div>
    <div class="hgap-6">
      @for (textButtonFlavor of textButtonFlavors; track textButtonFlavor) {
        <div class="gap-5">
          @for (textButtonSize of textButtonSizes; track textButtonSize) {
            <ng-container
              [ngTemplateOutlet]="text"
              [ngTemplateOutletContext]="{
                classes: ['button-' + textButtonSize, textButtonFlavor],
                text: 'Button ' + textButtonSize + ' ' + textButtonFlavor,
              }"
            >
            </ng-container>
          }
        </div>
      }
    </div>
  </div>
</div>

<div>
  <h2>{{ 'TYPOGRAPHY.COLORS' | translate }}</h2>
  <hr class="mb-6" />
  <div class="hgap-6">
    @for (textColor of textColors; track textColor) {
      <div class="gap-3">
        <p
          #el
          [class]="['text', textColor]"
          [vitamuiTooltip]="'TYPOGRAPHY.TOOLTIP' | translate: { classes: ['text', textColor].join(' ') }"
        >
          {{ textColor }}
        </p>
        <span class="info">{{ color(el) }}</span>
      </div>
    }
  </div>
</div>

<div>
  <h2>{{ 'TYPOGRAPHY.UPPERCASE' | translate }}</h2>
  <hr class="mb-6" />
  <div>
    <p class="text">
      Use "text uppercase" class to make it
      <span class="text uppercase" [vitamuiTooltip]="'TYPOGRAPHY.TOOLTIP' | translate: { classes: 'text uppercase' }">uppercase</span>
    </p>
  </div>
</div>

<div>
  <h2>{{ 'TYPOGRAPHY.TEXT_ELLIPSIS_TITLE' | translate }}</h2>
  <hr class="mb-6" />
  <div class="col-6" vitamuiCommonEllipsis>{{ 'TYPOGRAPHY.TEXT_ELLIPSIS_CONTENT' | translate }}</div>
</div>
